import {
  defaultConfigListFilter,
  configListColumnVisibilityOptions,
  defaultConfigListColumnVisibility,
} from '@utils/tables/configs/configListFilter';

// System
import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  selectedFilters: defaultConfigListFilter,
  columnVisibility: defaultConfigListColumnVisibility,
  columnVisibilityOptions: configListColumnVisibilityOptions,
  configTableFilters: {},
};

const configTableSlice = createSlice({
  name: 'roundTable',
  initialState,
  reducers: {
    setColumnVisibility: (state, { payload }) => {
      state.columnVisibility = payload;
    },
    setConfigTableFilters: (state, { payload }) => {
      const { codeName, value } = payload;
      const { configTableFilters } = state;

      let convertedValue: any;

      if (codeName === 'maxWin' || codeName === 'minBet' || codeName === 'maxBet') {
        convertedValue =
          typeof value === 'object' && typeof value.toNumber === 'function'
            ? value.toNumber()
            : Number(value);
      } else if (value === 'true') {
        convertedValue = true;
      } else if (value === 'false') {
        convertedValue = false;
      } else {
        convertedValue = value;
      }

      state.configTableFilters = {
        ...configTableFilters,
        [codeName]: convertedValue,
      };
    },
    setClearConfigTableFilters: (state) => {
      state.configTableFilters = {};
    },
  },
  extraReducers: {},
});

export const { reducer: configTableReducer } = configTableSlice;
export const { setColumnVisibility, setConfigTableFilters, setClearConfigTableFilters } =
  configTableSlice.actions;
